import { Spin } from 'antd';

import { Wrapper } from './loader.page-style';

interface LoaderPageProps {
  isDark?: boolean;
}

export const LoaderPage = ({ isDark = false }: LoaderPageProps) => (
  <Wrapper isDark={isDark}>
    <Spin size='large' />
  </Wrapper>
);
